var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_c('span',[_vm._v(_vm._s(_vm.formattedMinutes)+":"+_vm._s(_vm.formattedSeconds))])])
}
var staticRenderFns = []

export { render, staticRenderFns }